import $ from 'jquery';
import 'slick-carousel';

const testSlider = {
	init() {
		this.slideEls = document.querySelectorAll('.testimonial-slider-wrap');
		if (this.slideEls) {
			$(this.slideEls).slick(
				{
					arrows: true,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					loop: true,
					infinite: true,
					prevArrow: '<button id="prev" class="prev no-button-style"><span class="screen-reader-text">Previous</span><span class="dashicons dashicons-arrow-left-alt"></span></button>',
					nextArrow: '<button id="next" class="next no-button-style"><span class="screen-reader-text">Next</span><span class="dashicons dashicons-arrow-right-alt"></span></button>',
					rows: 0, // Remove extra <div> from slick markup.
				},
			);
		}
	},
};

testSlider.init();
